import React, { useState, useEffect } from 'react'
import './artigo.css'
import { TextField, MenuItem, Box, Skeleton } from '@mui/material';
import CountrySelect, { CountryType } from '../country/selectCountry';
import { useNavigate } from 'react-router-dom';
import api from '../../../../services/api';
import Date from '../../../../utils/date';

interface Artigo {
    _id: string;
    artigoTitulo: string;
    imagem: string;
    temaArtigo: string;
    tipoArtigo: string;
    editores: string;
    palavrasChaves: string;
    isbn: string;
    escritorio: string;
    anoPublicado: string;
    pais: string;
    visaoGeral: string;
    anexo: string;
    createdAt: string;
}


const ArtigosCientifico: React.FC = () => {
    const navigate = useNavigate();

    const [artigos, setArtigos] = useState<Artigo[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    // const [erro, setErro] = useState('');
    const [selectedCountry, setSelectedCountry] = useState<CountryType | null>(null);
    const countryLabel = selectedCountry?.label || ""
    const [filtro, setFiltro] = useState({
        palavrasChaves: '',
        tipoArtigo: '',
        temaArtigo: '',
        escritorio: '',
        ano: '',
    });

    const handleCountryChange = (_event: React.SyntheticEvent<Element, Event>, newValue: CountryType | null,) => {
        setSelectedCountry(newValue);
    };

    const handleChange = (event: any) => {
        setFiltro({ ...filtro, [event.target.name]: event.target.value });
    }

    useEffect(() => {
        setIsLoading(true);
        // setErro('');
        api.get(`/artigos-cientifico?palavrasChaves=${filtro.palavrasChaves}&tipoArtigo=${filtro.tipoArtigo}&temaArtigo=${filtro.temaArtigo}&escritorio=${filtro.escritorio}&anoPublicado=${filtro.ano}&pais=${countryLabel}`)
            .then(res => {
                setIsLoading(false);
                setArtigos(res.data.artigosCientifico);
            })
            .catch(() => {
                setIsLoading(false);
                // setErro("Ocorreu algum erro ao carregar os Artigos");
            });
    }, [filtro.palavrasChaves, filtro.tipoArtigo, filtro.temaArtigo, filtro.escritorio, filtro.ano, countryLabel])


    function SkeletonCard() {
        return (
            <Box>
                <Box sx={{ width: 210, marginRight: 0.5, my: 5 }} className="tw-h-[350px]">
                    <Skeleton animation="wave" variant="rectangular" width={210} className="tw-h-[200px]" />
                    <Box sx={{ pt: 0.5 }}>
                        <Skeleton animation="wave" />
                        <Skeleton animation="wave" width="60%" />
                    </Box>
                </Box>
            </Box>
        );
    }

    return (
        // <Container>
        <div className='artigo-home-artigo'>
            <div className='artigo-home'>
                <h1 style={{ fontSize: '24px' }}>Artigos Ciêntificos</h1>

                <p>Pesquisar artigos</p>

                <div className="artigo-filtro-section">
                    <TextField
                        name='palavrasChaves'
                        id="outlined-basic"
                        label="Pesquisa por Palavras-chaves"
                        variant="outlined"
                        className='artigo-txtTipo artigo-txt'
                        onChange={handleChange}
                    />
                    <TextField
                        disabled
                        id="outlined-select-currency"
                        select
                        label="Tipo"
                        className='artigo-txtTipo artigo-txt'
                        name='tipoArtigo'
                        onChange={handleChange}
                    >
                        {artigos.map((artigo) => (
                            <MenuItem key={artigo._id} value={artigo.tipoArtigo} >
                                {artigo.tipoArtigo}
                            </MenuItem>
                        ))}
                    </TextField>

                    <TextField
                        id="outlined-select-currency"
                        select
                        label="Tema"
                        className='artigo-txtTipo artigo-txt'
                        name='temaArtigo'
                        onChange={handleChange}
                    >
                        {artigos.map((artigo) => (
                            <MenuItem title={artigo.temaArtigo} key={artigo._id} value={artigo.temaArtigo} >
                                {artigo.temaArtigo.length > 50 ? artigo.temaArtigo.slice(0, 50) + '...' : artigo.temaArtigo}
                            </MenuItem>
                        ))}
                    </TextField>

                    <TextField
                        disabled
                        id="outlined-select-currency"
                        select
                        label="Escritório de Publicação"
                        className='artigo-txtTipo artigo-txt'
                        name='escritorio'
                        onChange={handleChange}
                    >
                        {artigos.map((artigo) => (
                            <MenuItem key={artigo._id} value={artigo.escritorio} >
                                {artigo.escritorio}
                            </MenuItem>
                        ))}
                    </TextField>

                    <CountrySelect
                        name="country"
                        value={selectedCountry}
                        handleChange={handleCountryChange}
                    />

                    <TextField
                        id="outlined-select-currency"
                        label="Ano"
                        className='artigo-anoTxt artigo-txt'
                        name='ano'
                        onChange={handleChange}
                        style={{ margin: '2px 0'}}
                    />

                    <TextField
                        disabled
                        id="outlined-select-currency"
                        label="Autor / Autores"
                        className='artigo-txtTipo artigo-txt artigo-autor'
                        name='autor'
                        onChange={handleChange}
                        style={{ margin: '2px 0' }}
                    />
                </div>

                {isLoading ?
                    <div className="artigo-pdf-article-cards-container" >
                        {
                            [...Array(4)].map((_, index) => (
                                <div className="artigo-pdf-article-card-card" style={{ cursor: 'progress' }} key={index}>
                                    <SkeletonCard />
                                </div>
                            ))
                        }
                    </div>
                    :
                    <div className="artigo-pdf-article-cards-container">
                        {artigos.map((artigo, index) => (
                            <div className="artigo-pdf-article-card-card" key={index}>
                                <div className="artigo-pdf-article-card-image">
                                    <img src={artigo.imagem} alt='imagem do artigo' />
                                </div>
                                <div className="artigo-pdf-article-card-info">
                                    <p className="artigo-pdf-article-card-date" style={{ fontSize: '16px', padding: '0', marginTop: '20px', textAlign: 'left' }}><Date date={artigo.createdAt}/></p>
                                    <h3 className="artigo-pdf-article-card-title">{artigo.artigoTitulo}</h3>
                                </div>
                                <div className="artigo-pdf-article-card-links">
                                    <a href={artigo.anexo} target="_blank" className="artigo-pdf-article-card-download">Baixar</a>
                                    <a href="" className="artigo-pdf-article-card-read-more">
                                        <div onClick={() => navigate(`/view-artigo-cientifico/${artigo._id}`)}>Leia Mais</div></a>
                                </div>
                            </div>
                        ))}
                    </div>
                }
            </div>
        </div>
        // </Container>
    )
}

export default ArtigosCientifico



// NOVO CODIGO, MELHORADO VISUALMENTE E COM MAIS RECURSOS DE FILTRAGEM
// import React, { useEffect, useMemo, useState } from "react";

// import {
//   Box,
//   Card,
//   CardContent,
//   Chip,
//   CircularProgress,
//   Container,
//   Grid,
//   MenuItem,
//   Skeleton,
//   TextField,
//   Typography,
//   Button,
// } from "@mui/material";

// import SearchIcon from "@mui/icons-material/Search";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import DownloadIcon from "@mui/icons-material/Download";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

// import CountrySelect, {
//   CountryType,
// } from "../country/selectCountry";

// import { useNavigate } from "react-router-dom";
// import api from "../../../../services/api";
// import Date from "../../../../utils/date";

// interface Artigo {
//   _id: string;
//   artigoTitulo: string;
//   imagem: string;
//   temaArtigo: string;
//   tipoArtigo: string;
//   editores: string;
//   palavrasChaves: string;
//   isbn: string;
//   escritorio: string;
//   anoPublicado: string;
//   pais: string;
//   visaoGeral: string;
//   anexo: string;
//   createdAt: string;
// }

// const ArtigosCientifico: React.FC = () => {
//   const navigate = useNavigate();

//   const [artigos, setArtigos] = useState<Artigo[]>([]);
//   const [isLoading, setIsLoading] = useState(false);

//   const [selectedCountry, setSelectedCountry] =
//     useState<CountryType | null>(null);

//   const [filtro, setFiltro] = useState({
//     palavrasChaves: "",
//     tipoArtigo: "",
//     temaArtigo: "",
//     escritorio: "",
//     ano: "",
//   });

//   const countryLabel = selectedCountry?.label || "";

//   const handleCountryChange = (
//     _: React.SyntheticEvent<Element, Event>,
//     newValue: CountryType | null
//   ) => {
//     setSelectedCountry(newValue);
//   };

//   const handleChange = (
//     event: React.ChangeEvent<HTMLInputElement>
//   ) => {
//     setFiltro({
//       ...filtro,
//       [event.target.name]: event.target.value,
//     });
//   };

//   useEffect(() => {
//     const loadArtigos = async () => {
//       try {
//         setIsLoading(true);

//         const response = await api.get(
//           `/artigos-cientifico?palavrasChaves=${filtro.palavrasChaves}&tipoArtigo=${filtro.tipoArtigo}&temaArtigo=${filtro.temaArtigo}&escritorio=${filtro.escritorio}&anoPublicado=${filtro.ano}&pais=${countryLabel}`
//         );

//         setArtigos(response.data.artigosCientifico || []);
//       } catch (error) {
//         console.log(error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     loadArtigos();
//   }, [filtro, countryLabel]);

//   // REMOVER DUPLICADOS
//   const temas = useMemo(
//     () => [
//       ...new Set(
//         artigos
//           .map((item) => item.temaArtigo)
//           .filter(Boolean)
//       ),
//     ],
//     [artigos]
//   );

//   const tipos = useMemo(
//     () => [
//       ...new Set(
//         artigos
//           .map((item) => item.tipoArtigo)
//           .filter(Boolean)
//       ),
//     ],
//     [artigos]
//   );

//   const escritorios = useMemo(
//     () => [
//       ...new Set(
//         artigos
//           .map((item) => item.escritorio)
//           .filter(Boolean)
//       ),
//     ],
//     [artigos]
//   );

//   function SkeletonCard() {
//     return (
//       <Card
//         sx={{
//           borderRadius: 5,
//           overflow: "hidden",
//           boxShadow: "0 8px 30px rgba(0,0,0,0.06)",
//         }}
//       >
//         <Skeleton
//           variant="rectangular"
//           height={220}
//         />

//         <CardContent>
//           <Skeleton height={30} />
//           <Skeleton width="80%" />
//           <Skeleton width="40%" />
//         </CardContent>
//       </Card>
//     );
//   }

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         background:
//           "linear-gradient(to bottom, #f8fafc, #ffffff)",
//         py: 6,
//       }}
//     >
//       <Container maxWidth="xl">

//         {/* HERO */}
//         <Box
//           sx={{
//             position: "relative",
//             overflow: "hidden",
//             borderRadius: "32px",
//             background:
//               "linear-gradient(135deg, #0f172a 0%, #111827 100%)",
//             p: { xs: 4, md: 8 },
//             mb: 6,
//             color: "#fff",
//           }}
//         >
//           <Box
//             sx={{
//               position: "absolute",
//               inset: 0,
//               opacity: 0.08,
//               backgroundImage:
//                 "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
//               backgroundSize: "30px 30px",
//             }}
//           />

//           <Box sx={{ position: "relative", zIndex: 1 }}>
//             <Chip
//               label="Biblioteca Científica"
//               sx={{
//                 mb: 3,
//                 bgcolor: "rgba(255,255,255,0.12)",
//                 color: "#fff",
//                 backdropFilter: "blur(10px)",
//               }}
//             />

//             <Typography
//               variant="h3"
//               fontWeight={900}
//             >
//               Artigos Científicos
//             </Typography>

//             <Typography
//               sx={{
//                 mt: 2,
//                 maxWidth: 800,
//                 color: "rgba(255,255,255,0.8)",
//               }}
//             >
//               Explore pesquisas, publicações e artigos
//               científicos disponíveis na plataforma.
//               Pesquise por tema, país, ano e palavras-chave.
//             </Typography>
//           </Box>
//         </Box>

//         {/* FILTROS */}
//         <Card
//           sx={{
//             borderRadius: "28px",
//             mb: 6,
//             boxShadow: "0 10px 40px rgba(0,0,0,0.06)",
//             border: "1px solid #e2e8f0",
//           }}
//         >
//           <CardContent sx={{ p: 4 }}>

//             <Box
//               display="flex"
//               alignItems="center"
//               gap={2}
//               mb={4}
//             >
//               <Box
//                 sx={{
//                   width: 52,
//                   height: 52,
//                   borderRadius: "16px",
//                   bgcolor: "#0f172a",
//                   color: "#fff",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <SearchIcon />
//               </Box>

//               <Box>
//                 <Typography
//                   variant="h5"
//                   fontWeight={800}
//                 >
//                   Pesquisar Artigos
//                 </Typography>

//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                 >
//                   Utilize os filtros abaixo para localizar
//                   artigos científicos.
//                 </Typography>
//               </Box>
//             </Box>

//             <Grid container spacing={3}>

//               {/* PALAVRAS CHAVES */}
//               <Grid item xs={12} md={6} lg={4}>
//                 <TextField
//                   fullWidth
//                   label="Palavras-chave"
//                   name="palavrasChaves"
//                   value={filtro.palavrasChaves}
//                   onChange={handleChange}
//                 />
//               </Grid>

//               {/* TIPO */}
//               <Grid item xs={12} md={6} lg={4}>
//                 <TextField
//                   select
//                   fullWidth
//                   label="Tipo de Artigo"
//                   name="tipoArtigo"
//                   value={filtro.tipoArtigo}
//                   onChange={handleChange}
//                 >
//                   <MenuItem value="">
//                     Todos
//                   </MenuItem>

//                   {tipos.map((tipo) => (
//                     <MenuItem
//                       key={tipo}
//                       value={tipo}
//                     >
//                       {tipo}
//                     </MenuItem>
//                   ))}
//                 </TextField>
//               </Grid>

//               {/* TEMA */}
//               <Grid item xs={12} md={6} lg={4}>
//                 <TextField
//                   select
//                   fullWidth
//                   label="Tema"
//                   name="temaArtigo"
//                   value={filtro.temaArtigo}
//                   onChange={handleChange}
//                 >
//                   <MenuItem value="">
//                     Todos
//                   </MenuItem>

//                   {temas.map((tema) => (
//                     <MenuItem
//                       key={tema}
//                       value={tema}
//                     >
//                       {tema}
//                     </MenuItem>
//                   ))}
//                 </TextField>
//               </Grid>

//               {/* ESCRITORIO */}
//               <Grid item xs={12} md={6} lg={4}>
//                 <TextField
//                   select
//                   fullWidth
//                   label="Escritório"
//                   name="escritorio"
//                   value={filtro.escritorio}
//                   onChange={handleChange}
//                 >
//                   <MenuItem value="">
//                     Todos
//                   </MenuItem>

//                   {escritorios.map((escritorio) => (
//                     <MenuItem
//                       key={escritorio}
//                       value={escritorio}
//                     >
//                       {escritorio}
//                     </MenuItem>
//                   ))}
//                 </TextField>
//               </Grid>

//               {/* PAÍS */}
//               <Grid item xs={12} md={6} lg={4}>
//                 <CountrySelect
//                   name="country"
//                   value={selectedCountry}
//                   handleChange={handleCountryChange}
//                 />
//               </Grid>

//               {/* ANO */}
//               <Grid item xs={12} md={6} lg={4}>
//                 <TextField
//                   fullWidth
//                   label="Ano de Publicação"
//                   name="ano"
//                   value={filtro.ano}
//                   onChange={handleChange}
//                 />
//               </Grid>

//             </Grid>

//           </CardContent>
//         </Card>

//         {/* LOADING */}
//         {isLoading ? (
//           <Grid container spacing={4}>
//             {[...Array(8)].map((_, index) => (
//               <Grid
//                 item
//                 xs={12}
//                 sm={6}
//                 lg={3}
//                 key={index}
//               >
//                 <SkeletonCard />
//               </Grid>
//             ))}
//           </Grid>
//         ) : artigos.length > 0 ? (
//           <>

//             {/* TOPO */}
//             <Box
//               display="flex"
//               justifyContent="space-between"
//               alignItems="center"
//               mb={4}
//               flexWrap="wrap"
//               gap={2}
//             >
//               <Typography
//                 variant="h5"
//                 fontWeight={800}
//               >
//                 Resultados Encontrados
//               </Typography>

//               <Chip
//                 label={`${artigos.length} artigos`}
//                 sx={{
//                   bgcolor: "#0f172a",
//                   color: "#fff",
//                   fontWeight: 600,
//                 }}
//               />
//             </Box>

//             {/* LISTA */}
//             <Grid container spacing={4}>

//               {artigos.map((artigo) => (
//                 <Grid
//                   item
//                   xs={12}
//                   sm={6}
//                   lg={3}
//                   key={artigo._id}
//                 >
//                   <Card
//                     sx={{
//                       height: "100%",
//                       borderRadius: "28px",
//                       overflow: "hidden",
//                       border: "1px solid #e2e8f0",
//                       transition: ".3s",
//                       boxShadow:
//                         "0 6px 25px rgba(0,0,0,0.05)",

//                       "&:hover": {
//                         transform: "translateY(-6px)",
//                         boxShadow:
//                           "0 18px 45px rgba(0,0,0,0.12)",
//                       },
//                     }}
//                   >

//                     {/* IMAGEM */}
//                     <Box
//                       sx={{
//                         position: "relative",
//                         height: 240,
//                         overflow: "hidden",
//                       }}
//                     >
//                       <Box
//                         component="img"
//                         src={artigo.imagem}
//                         alt={artigo.artigoTitulo}
//                         sx={{
//                           width: "100%",
//                           height: "100%",
//                           objectFit: "cover",
//                           transition: ".6s",

//                           "&:hover": {
//                             transform: "scale(1.08)",
//                           },
//                         }}
//                       />

//                       <Box
//                         sx={{
//                           position: "absolute",
//                           inset: 0,
//                           background:
//                             "linear-gradient(to top, rgba(0,0,0,.7), transparent)",
//                         }}
//                       />

//                       <Chip
//                         label={
//                           artigo.tipoArtigo || "Artigo"
//                         }
//                         sx={{
//                           position: "absolute",
//                           top: 16,
//                           left: 16,
//                           bgcolor:
//                             "rgba(255,255,255,0.15)",
//                           color: "#fff",
//                           backdropFilter: "blur(10px)",
//                         }}
//                       />
//                     </Box>

//                     {/* CONTEUDO */}
//                     <CardContent
//                       sx={{
//                         display: "flex",
//                         flexDirection: "column",
//                         height: "calc(100% - 240px)",
//                       }}
//                     >

//                       {/* DATA */}
//                       <Box
//                         display="flex"
//                         alignItems="center"
//                         gap={1}
//                         mb={2}
//                         color="text.secondary"
//                       >
//                         <CalendarMonthIcon
//                           sx={{ fontSize: 18 }}
//                         />

//                         <Typography variant="body2">
//                           <Date
//                             date={artigo.createdAt}
//                           />
//                         </Typography>
//                       </Box>

//                       {/* TITULO */}
//                       <Typography
//                         variant="h6"
//                         fontWeight={800}
//                         sx={{
//                           lineHeight: 1.4,
//                           mb: 2,
//                           minHeight: 70,
//                         }}
//                       >
//                         {artigo.artigoTitulo}
//                       </Typography>

//                       {/* TEMA */}
//                       <Typography
//                         variant="body2"
//                         color="text.secondary"
//                         sx={{
//                           mb: 3,
//                           flexGrow: 1,
//                         }}
//                       >
//                         {artigo.temaArtigo}
//                       </Typography>

//                       {/* TAGS */}
//                       <Box
//                         display="flex"
//                         gap={1}
//                         flexWrap="wrap"
//                         mb={3}
//                       >
//                         {artigo.pais && (
//                           <Chip
//                             label={artigo.pais}
//                             size="small"
//                           />
//                         )}

//                         {artigo.anoPublicado && (
//                           <Chip
//                             label={
//                               artigo.anoPublicado
//                             }
//                             size="small"
//                             color="primary"
//                           />
//                         )}
//                       </Box>

//                       {/* BOTÕES */}
//                       <Box
//                         display="flex"
//                         gap={1.5}
//                       >
//                         <Button
//                           fullWidth
//                           variant="outlined"
//                           href={artigo.anexo}
//                           target="_blank"
//                           startIcon={<DownloadIcon />}
//                           sx={{
//                             borderRadius: "14px",
//                             py: 1.2,
//                           }}
//                         >
//                           Baixar
//                         </Button>

//                         <Button
//                           fullWidth
//                           variant="contained"
//                           endIcon={
//                             <ArrowForwardIcon />
//                           }
//                           onClick={() =>
//                             navigate(
//                               `/view-artigo-cientifico/${artigo._id}`
//                             )
//                           }
//                           sx={{
//                             borderRadius: "14px",
//                             py: 1.2,
//                             bgcolor: "#0f172a",

//                             "&:hover": {
//                               bgcolor: "#111827",
//                             },
//                           }}
//                         >
//                           Ler Mais
//                         </Button>
//                       </Box>

//                     </CardContent>

//                   </Card>
//                 </Grid>
//               ))}

//             </Grid>
//           </>
//         ) : (
//           <Card
//             sx={{
//               borderRadius: "32px",
//               border: "1px solid #e2e8f0",
//               minHeight: 400,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               textAlign: "center",
//             }}
//           >
//             <CardContent>

//               <Box
//                 sx={{
//                   width: 90,
//                   height: 90,
//                   borderRadius: "50%",
//                   bgcolor: "#f1f5f9",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   margin: "0 auto 24px auto",
//                 }}
//               >
//                 <SearchIcon
//                   sx={{
//                     fontSize: 40,
//                     color: "#0f172a",
//                   }}
//                 />
//               </Box>

//               <Typography
//                 variant="h5"
//                 fontWeight={800}
//               >
//                 Nenhum artigo encontrado
//               </Typography>

//               <Typography
//                 variant="body1"
//                 color="text.secondary"
//                 sx={{
//                   mt: 2,
//                   maxWidth: 500,
//                 }}
//               >
//                 Não encontramos resultados para os
//                 filtros selecionados. Tente ajustar os
//                 critérios de pesquisa.
//               </Typography>

//             </CardContent>
//           </Card>
//         )}

//         {/* FLOAT LOADING */}
//         {isLoading && (
//           <Box
//             sx={{
//               position: "fixed",
//               right: 24,
//               bottom: 24,
//               width: 60,
//               height: 60,
//               borderRadius: "50%",
//               bgcolor: "#0f172a",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               boxShadow:
//                 "0 12px 30px rgba(0,0,0,0.25)",
//               zIndex: 999,
//             }}
//           >
//             <CircularProgress
//               size={24}
//               sx={{ color: "#fff" }}
//             />
//           </Box>
//         )}

//       </Container>
//     </Box>
//   );
// };

// export default ArtigosCientifico;